import { useAtom } from "jotai";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { currentIdAtom, currentIndexAtom, fieldObjectsAtom, fieldsActionAtom } from "../state/global.state";
import type { FieldObject } from "../types/fieldObject";

type Props = {
  fieldObject: FieldObject;
  index: number;
};
export const InputButton: FC<Props> = ({ fieldObject, index }) => {
  const [name, setName] = useState(fieldObject.name);
  const [fieldObjects, setFieldObjects] = useAtom(fieldObjectsAtom);
  const [fieldsAction, setFieldsAction] = useAtom(fieldsActionAtom);
  const [, setCurrentId] = useAtom(currentIdAtom);
  const [currentIndex, setCurrentIndex] = useAtom(currentIndexAtom);

  const checkStatus = index == currentIndex;
  const statusClass = checkStatus ? "bg-white" : "text-white hover:bg-slate-500";

  useEffect(() => {
    const newFieldObjects = [...fieldObjects];
    newFieldObjects[index].name = name;
    setFieldObjects(() => newFieldObjects);
    setFieldsAction(!fieldsAction);
  }, [name]);

  const removeHandler = () => {
    const removedFieldObject = fieldObjects.filter((object) => {
      return object.id != fieldObject.id;
    });
    const result = confirm("Delete?");
    if (result) {
      if (index < currentIndex) {
        setCurrentIndex(currentIndex - 1);
      }
      setFieldObjects(() => removedFieldObject);
      setFieldsAction(!fieldsAction);
    }
  };
  return (
    <div className="relative flex justify-center items-center rounded-full">
      <button
        className={`rounded-full max-w-[130px] overflow-hidden px-5 py-3 h-9 flex justify-center items-center cursor-pointer ${statusClass} duration-300 transition-all ${
          !checkStatus && "pr-6"
        }`}
        onClick={() => {
          setCurrentId(fieldObject.id);
          setCurrentIndex(index);
          return;
        }}
      >
        <input
          onChange={(e) => {
            setName(e.target.value);
            return;
          }}
          disabled={!checkStatus}
          type="text"
          value={name}
          className={`max-w-full text-center overflow-ellipsis !bg-transparent rounded ${
            checkStatus == false && "cursor-pointer"
          }`}
        />
      </button>
      {!checkStatus && (
        <button
          id={`${fieldObject.id}_nav_delete`}
          className={`absolute flex right-[10px] h-full top-0 opacity-40 items-center text-white`}
          onClick={(e) => {
            e.preventDefault();
            removeHandler();
          }}
          onTouchStart={(e) => {
            e.preventDefault();
            removeHandler();
          }}
        >
          <IoClose />
        </button>
      )}
    </div>
  );
};
